export default "__VITE_ASSET__Bwg94SvR__"